import { NoAccessHeader } from 'components/Header/NoAccessHeader'
import { NoAccessSign } from 'components/NoAccessSign'

import type { FC } from 'react'

export const NoAccessPage: FC = () => (
  <>
    <NoAccessHeader />
    <div className="flex min-h-screen items-center justify-center">
      <NoAccessSign />
    </div>
  </>
)
